import styled from '@emotion/styled';

export const ItemTitle = styled('div')((p) => ({
  display: 'flex',
  alignItems: 'center',
  gap: p.theme.spacing()
}));

export const TaskAndAutomationList = styled('div')((p) => ({
  display: 'grid',
  gridTemplateColumns: '1fr',
  gridRowGap: p.theme.spacing()
}));

export const InnerItemRow = styled('div')((p) => ({
  width: '100%',
  color: p.theme.custom.colors.gray.w500,
  marginBottom: p.theme.spacing(),
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: p.theme.spacing()
}));

export const InnerItemList = styled('div')((p) => ({
  marginLeft: 0
}));

export const InnerItemGroup = styled('div')((p) => ({
  position: 'relative',
  paddingLeft: p.theme.spacing(1),

  '&:before': {
    content: '""',
    position: 'absolute',
    width: p.theme.spacing(0.25),
    height: '100%',
    left: 0,
    backgroundColor: p.theme.custom.colors.gray.w200,
    borderRadius: p.theme.custom.border.radius()
  }
}));

export const InnerItemDetail = styled('div')((p) => ({
  display: 'flex',
  alignItems: 'center',
  gap: p.theme.spacing()
}));

export const ErrorText = styled('div')((p) => ({
  color: p.theme.palette.error.main
}));

export const TabContainer = styled('div')`
  margin-top: ${(p) => p.theme.spacing(3)}px;
`;
